/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AuditLogsPageableResponseDto } from '../models';
/**
 * RestAuditLogsApi - axios parameter creator
 */
export const RestAuditLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Requires ROLE_READ. Every change of a user\'s role, of a role (creation, change, deletion), of a role\'s permission set and of a user\'s additional permissions leaves one ROLE_CHANGE entry describing what changed and for whom. Entries are ordered from the newest.
         * @summary Get the history of changes to authorization, newest first
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogs: async (page: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAuditLogs', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getAuditLogs', 'pageSize', pageSize)
            const localVarPath = `/api/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAuditLogsApi - functional programming interface
 */
export const RestAuditLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAuditLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Requires ROLE_READ. Every change of a user\'s role, of a role (creation, change, deletion), of a role\'s permission set and of a user\'s additional permissions leaves one ROLE_CHANGE entry describing what changed and for whom. Entries are ordered from the newest.
         * @summary Get the history of changes to authorization, newest first
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditLogs(page: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogsPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLogs(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAuditLogsApi.getAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAuditLogsApi - factory interface
 */
export const RestAuditLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAuditLogsApiFp(configuration)
    return {
        /**
         * Requires ROLE_READ. Every change of a user\'s role, of a role (creation, change, deletion), of a role\'s permission set and of a user\'s additional permissions leaves one ROLE_CHANGE entry describing what changed and for whom. Entries are ordered from the newest.
         * @summary Get the history of changes to authorization, newest first
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogs(page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<AuditLogsPageableResponseDto> {
            return localVarFp.getAuditLogs(page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAuditLogsApi - interface
 */
export interface RestAuditLogsApiInterface {
    /**
     * Requires ROLE_READ. Every change of a user\'s role, of a role (creation, change, deletion), of a role\'s permission set and of a user\'s additional permissions leaves one ROLE_CHANGE entry describing what changed and for whom. Entries are ordered from the newest.
     * @summary Get the history of changes to authorization, newest first
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuditLogs(page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<AuditLogsPageableResponseDto>;

}

/**
 * RestAuditLogsApi - object-oriented interface
 */
export class RestAuditLogsApi extends BaseAPI implements RestAuditLogsApiInterface {
    /**
     * Requires ROLE_READ. Every change of a user\'s role, of a role (creation, change, deletion), of a role\'s permission set and of a user\'s additional permissions leaves one ROLE_CHANGE entry describing what changed and for whom. Entries are ordered from the newest.
     * @summary Get the history of changes to authorization, newest first
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuditLogs(page: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return RestAuditLogsApiFp(this.configuration).getAuditLogs(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

